/* eslint-disable no-nested-ternary */
import type { BreedFciGroupType, BreedMaintenanceType } from '@application/types';
import { useRouter } from '@application/utils';
import type { AnimalSizeEnum, DogHairType, DogType } from '@gql/graphql';
import type { BreedListPageFormValues } from '@presentation/pages';
import { useCallback, useMemo } from 'react';
import { FORM_INITIAL_VALUES } from './constants';

export const useSearch = () => {
  const { infoFromCurrentPath, setCurrentSearch } = useRouter();

  const setSearchFromValues = useCallback(
    (values: BreedListPageFormValues) => {
      setCurrentSearch({
        page: 1,
        ...(values.allergic != null && { allergic: values.allergic.toString() }),
        ...(values.independant != null && { independant: values.independant.toString() }),
        size: values.size,
        dogType: values.dogType,
        maintenanceType: values.maintenanceType,
        fciGroupType: values.fciGroupType,
        hairType: values.hairType,
      });
    },
    [setCurrentSearch],
  );

  const valuesFromSearch = useMemo((): Partial<BreedListPageFormValues> => {
    const { allergic, independant, size, dogType, maintenanceType, fciGroupType, hairType } =
      infoFromCurrentPath.search ?? {};

    return {
      allergic:
        allergic === 'true' ? true : allergic === 'false' ? false : FORM_INITIAL_VALUES.allergic,
      independant:
        independant === 'true'
          ? true
          : independant === 'false'
          ? false
          : FORM_INITIAL_VALUES.independant,
      size: (size as AnimalSizeEnum[]) ?? FORM_INITIAL_VALUES.size,
      dogType: (dogType as DogType[]) ?? FORM_INITIAL_VALUES.dogType,
      maintenanceType:
        (maintenanceType as BreedMaintenanceType[]) ?? FORM_INITIAL_VALUES.maintenanceType,
      fciGroupType: (fciGroupType as BreedFciGroupType[]) ?? FORM_INITIAL_VALUES.fciGroupType,
      hairType: (hairType as DogHairType[]) ?? FORM_INITIAL_VALUES.hairType,
    };
  }, [infoFromCurrentPath.search]);

  return { setSearchFromValues, valuesFromSearch };
};
